

<p-panelMenu [model]="sidebarItem" styleClass="p.panelmenu" >

</p-panelMenu>

